"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function BannerIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props, { viewBox: "0 0 174 23" }),
        react_1.default.createElement("path", { d: "M1.02743 2.79794C0.452694 1.47699 1.4208 0 2.86136 0H171.259C172.699 0 173.667 1.47699 173.093 2.79794L169.839 10.2767C169.617 10.7856 169.617 11.3636 169.839 11.8726L173.093 19.3513C173.667 20.6722 172.699 22.1492 171.259 22.1492H2.86136C1.4208 22.1492 0.452694 20.6722 1.02744 19.3513L4.28142 11.8726C4.50285 11.3636 4.50285 10.7856 4.28142 10.2767L1.02743 2.79794Z" })));
}
exports.default = BannerIcon;
